export const UPDATE_BINARY_STATUS = 'UPDATE_BINARY_STATUS';

export function updateBinaryStatus(payload: {
  status?: string;
  selectedFolder?: string;
  pid?: string;
  port?: string | number;
}) {
  return {
    type: UPDATE_BINARY_STATUS,
    payload,
  };
}
